var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "home_svg__dr",
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "home_svg__ds",
    x1: 257.96,
    y1: 107.09,
    x2: 330.34,
    y2: 107.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4690ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home_svg__dt",
    x1: 161.33,
    y1: 307.48,
    x2: 269.9,
    y2: 307.48,
    xlinkHref: "#home_svg__ds"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m317.56,156.81c6.87,0,12.46-5.59,12.46-12.46v-7.89c.2-.89.31-1.81.31-2.75l-.13-63.07c0-1.02-.14-2-.38-2.95-.45-2.5-1.64-4.85-3.45-6.65-2.32-2.32-5.53-3.65-8.81-3.65h-47.14c-3.28,0-6.49,1.33-8.81,3.65-2.32,2.32-3.65,5.53-3.65,8.81v30.56c0,6.87,5.59,12.46,12.46,12.46s12.46-5.59,12.46-12.46v-18.09h22.21v62.04c0,6.87,5.59,12.46,12.46,12.46Z",
    style: {
      fill: "url(#home_svg__ds)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m257.44,389.06c6.87,0,12.46-5.59,12.46-12.46v-138.23c0-3.28-1.33-6.49-3.65-8.81-2.32-2.32-5.53-3.65-8.81-3.65h-83.64c-3.28,0-6.49,1.33-8.81,3.65-2.32,2.32-3.65,5.53-3.65,8.81v138.23c0,6.87,5.59,12.46,12.46,12.46s12.46-5.59,12.46-12.46v-125.76h58.72v125.76c0,6.87,5.59,12.46,12.46,12.46Z",
    style: {
      fill: "url(#home_svg__dt)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m59.08,213.64l10.09-9.22v172.18c0,3.28,1.33,6.49,3.65,8.81,2.32,2.32,5.53,3.65,8.81,3.65h264.86c.14,0,.28.02.42.02h0c.17,0,.35-.01.52-.02h.46c3.28,0,6.49-1.33,8.81-3.65,2.32-2.32,3.65-5.53,3.65-8.81v-171.74l9.41,8.72c2.31,2.14,5.32,3.32,8.47,3.32.13,0,.26-.02.4-.02.19,0,.38.03.57.03h.12c6.87,0,12.46-5.59,12.46-12.46,0-3.99-1.9-7.71-5.1-10.05,0,0-35.42-32.84-66.55-61.7-1-.93-2.13-1.66-3.34-2.21l-56.37-52.26c-.64-1.17-1.46-2.24-2.46-3.17l-28.75-26.65c-1.95-4.49-6.4-7.47-11.42-7.47-.92,0-1.85.11-2.76.32-2.91.13-5.68,1.26-7.84,3.23L42.26,195.24c-5.07,4.64-5.43,12.54-.79,17.61,2.36,2.58,5.71,4.05,9.2,4.05,3.12,0,6.1-1.16,8.41-3.26Zm35.02-32.01l121.46-111.02,120.47,111.69c-.38,1.2-.6,2.47-.6,3.8v17.24c-.03.35-.05.7-.05,1.05v159.75H94.1v-182.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.dc8fe274d996531fbcee7cfc81fa098e.svg";
export { ForwardRef as ReactComponent };